import styled from 'styled-components';

export const StyledDiv = styled.div`
	.features-container {
		max-width: 930px;
		margin: 0 auto;
		display: flex;
		flex-direction: column;
		gap: 100px;

		&.full-width {
			max-width: 1420px;
		}

		.feature {
			align-items: center;

			.feature-img-wrapper {
				margin: 0 auto;
			}

			.content .details-wrapper p {
				max-width: 930px;
			}
		}

		&.about-us {
			max-width: 1420px;

			.feature {
				align-items: center;

				.content .details-wrapper p {
					max-width: 650px;
				}
			}
		}

		.info-list-container.left-to-right-slide {
			.list-item {
				&:after,
				&:before {
					display: none;
					@media screen and (min-width: 860px) {
						display: block;
					}
				}
			}
		}
		.info-list-container.right-to-left-slide {
			.list-item {
				align-items: flex-start;
				&:before {
					display: none;
				}
				&:after {
					display: none;
				}
			}
		}
	}

	.main-image {
		display: flex;
		justify-content: center;
		align-items: center;
		margin: 0 auto;
		max-width: 100%;
		/* width: 100%; */
		height: 100%;
	}
`;
